"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactDesc = require("react-desc"); // @ts-ignore no module typings


var schema = (0, _reactDesc.describe)({
  displayName: 'SelectMenu'
});
schema.propTypes = {
  defaultSelected: _reactDesc.PropTypes.string.description('This ID will appear as selected the first time the user opens the dropdown.'),
  disabled: _reactDesc.PropTypes.bool.description('Disables functionality of opening the options list.'),
  label: _reactDesc.PropTypes.string.description('The label text for the select menu.').isRequired,
  onChange: _reactDesc.PropTypes.func.description("An event handler called when the selected option should be changed. Called with the new option's id.").isRequired,
  actions: _reactDesc.PropTypes.oneOfType([_reactDesc.PropTypes.arrayOf(_reactDesc.PropTypes.object), _reactDesc.PropTypes.shape({
    left: _reactDesc.PropTypes.arrayOf(_reactDesc.PropTypes.object),
    right: _reactDesc.PropTypes.arrayOf(_reactDesc.PropTypes.object)
  })]).description('A collection of objects, each containing a subset of props valid for a Button component. Check the notes on the OptionsList.'),
  options: _reactDesc.PropTypes.arrayOf(_reactDesc.PropTypes.shape({
    decoration: _reactDesc.PropTypes.shape({
      type: _reactDesc.PropTypes.oneOf(['Avatar', 'Badge'])
    }),
    disabled: _reactDesc.PropTypes.bool,
    id: _reactDesc.PropTypes.string,
    label: _reactDesc.PropTypes.string.description('The label text for an option in the dropdown list.'),
    value: _reactDesc.PropTypes.oneOfType([_reactDesc.PropTypes.number, _reactDesc.PropTypes.string]).description('The value for an option in the dropdown list.')
  })).description('The array of option data that will be rendered').isRequired,
  selected: _reactDesc.PropTypes.string.description('Used when component is controlled. Defines the item(s) selected in the dropdown. Can not be used at the same time as `defaultSelected`.'),
  allSelectedLabel: _reactDesc.PropTypes.string.description('Allows to override the button label when all options are selected.').defaultValue('All'),
  noneSelectedLabel: _reactDesc.PropTypes.string.description('Allows to override the button label when none of the options are selected.').defaultValue('All'),
  multiple: _reactDesc.PropTypes.bool.description('Enables multiple selections.').defaultValue(false),
  size: _reactDesc.PropTypes.oneOf(['small', 'medium']).description('Controls the size of the text being rendered.').defaultValue('medium'),
  zIndex: _reactDesc.PropTypes.number.description('Sets the z-index style property of the options list')
};
var _default = schema;
exports.default = _default;